(($) => {
    $(document).on('ready', init);

    function init() {
        bind();
    }

    function bind() {
        $('html').on('bb-lumeris:lum-button:init', moduleInit);
    }

    function hasAnalyticsConsent() {
        return (typeof Cookiebot !== 'undefined') ? Cookiebot.consent?.statistics : true;
    }

    function moduleInit(event, data) {
        if (!event || !data) {
            return;
        }

        const $module = $(`.fl-node-${data.node}`);
        
        $module.find('a').on('click', (event) => {
            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'cta_link_click' }}));

            if ((data.settings?.event_on_click_active ?? null == 'yes') && window.dataLayer && hasAnalyticsConsent()) {
                event.preventDefault();

                const button = event.target;
                const id = button.id.trim();
                const label = button.text.trim();
                const href = button.href.trim();
                const target = button.target.trim();
                const timeout = 2000;

                const callback = () => {
                    switch (target) {
                        case '_blank': return window.open(href, '_blank');
                        case '_parent': return window.parent.location = href;
                        case '_top': return window.top.location = href;
                    }

                    return window.location.href = href;
                };

                dataLayer.push({
                    event: 'buttonClick',
                    id: data.node,
                    label: label,
                    linkUrl: href,
                    pageUrl: location.href,
                    eventCallback: callback,
                    eventTimeout: timeout
                });

                setTimeout(callback, timeout);
            }
        });
    }
})(jQuery);